package anjuros.development.components

import androidx.compose.runtime.Composable
import anjuros.development.components.language.LocalText
import anjuros.development.modules.Nearby
import anjuros.development.util.Constants
import anjuros.development.util.Constants.FONT_FAMILY
import anjuros.development.util.NearbyRotationStyle
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PhotoCard(
    nearby: Nearby,
    animatedOpacity: Float
) {
    Link(path = nearby.link,
        modifier=Modifier.textDecorationLine(TextDecorationLine.None),
        openInternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB) {

        Column(
            modifier = NearbyRotationStyle.toModifier()
                .backgroundColor(Colors.White)
                .margin(40.px)
                .borderRadius(8.px) // Adds rounded corners
                .opacity(animatedOpacity)
                .transition(
                    Transition.of(
                        property = "opacity", duration = 500.ms,
                        delay = 500.ms * nearby.ordinal
                    )
                )
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 2.px,
                    blurRadius = 8.px,
                    color = Colors.Black.copy(alpha = 15) // Subtle shadow
                )
                .padding(16.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Image(
                src = nearby.image,
                description = LocalText(nearby.description),
                modifier = Modifier
                    .fillMaxWidth()
                    .aspectRatio(1.5f)
                    .objectFit(ObjectFit.Cover)
                    .borderRadius(4.px)
            )

            P(
                attrs = Modifier
                    .textAlign(TextAlign.Center)
                    .fillMaxWidth()
                    .fontFamily(FONT_FAMILY)
                    .margin(top = 16.px)
                    .fontSize(20.px)
                    .color(Colors.Black)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(LocalText(nearby.description))

            }

            P(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Center)
                    .fontFamily(FONT_FAMILY)
                    .margin(top = 4.px)
                    .fontSize(14.px)
                    .color(Colors.Gray)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(nearby.distance)

            }
        }
    }
}
